<template>
    <div id = 'userNavigation'>
        <div class="navbar-fixed">
            <ul id="dropdown" class="dropdown-content">
                <li>
                    <router-link to="/user/profile" class="sidenav-close"> {{$t('user.myProfile')}} </router-link>
                </li>
                <li class="divider"></li>
                <li>
                    <a class="" v-on:click="logoutBtnTapped"> {{$t('user.logout')}} </a>
                </li>
            </ul>
            <nav style="background-color: #292929">
                <a href="#" data-target="slide-out" class="sidenav-trigger right"><i class="material-icons">menu</i></a>
                <div class="navContainer nav-wrapper">
                    <div class="brand-logo left">
                        <a href="/" style="position: relative; top: 6px;"> 
                            <img src="../assets/SmartX_Logo.png" width="141.6" height="35">  
                        </a>
                    </div>

                    <ul id="nav-mobile" class='right'>
                        <li>
                            <a href="tel:+49.40.30740117" class="hide-on-med-and-down" style="font-size: 16px; color: #F0F0F0"> <span style='font-weight: bold'> call: </span>  +49.40.30740117 </a>
                        </li>

                        <li>
                            <a href="tel:+49.40.30740117" class="hide-on-large-only" style="font-size: 16px; color: #F0F0F0; padding-right: 0px">  <i class="material-icons">call</i>  </a>
                        </li>

                        <li>
                            <a href="mailto:mail@smartXelements.de" class="hide-on-med-and-down" style="font-size: 16px; color: #F0F0F0"> <span style='font-weight: bold'> write: </span> mail@smartXelements.de </a>
                        </li>

                        <li>
                            <a href="mailto:mail@smartXelements.de" class="hide-on-large-only" style="font-size: 16px; color: #F0F0F0; padding-right: 0px"> <i class="material-icons">email</i>  </a>
                        </li>

                        <li>
                            <a class="btn-floating dropdown-trigger" data-target="dropdown" style="background-color: #313131">
                                <!-- <i class="material-icons" style="font-size: 40px; background-color: #313131">account_circle</i> -->
                                <img src="../assets/profileIcon.png" style="padding: 2px; background-color: #292929">
                            </a>
                        </li>

                        <li v-if="currentLang == 'de'">
                            <a href="#" @click="currentLang = 'de'" style="padding: 0px; text-decoration: underline; font-weight: bold; color: #F0F0F0"> DE </a>
                        </li>
                        <li v-else>
                            <a href="#" @click="currentLang = 'de'" style="padding: 0px; color: #F0F0F0;"> DE </a>
                        </li>

                        <li>
                            <a href="#" style="padding-left: 5px; padding-right: 5px; color: #F0F0F0"> | </a>
                        </li>

                        <li v-if="currentLang == 'en'">
                            <a href="#" @click="currentLang = 'en'" style="padding: 0px; text-decoration: underline; font-weight: bold; color: #F0F0F0"> EN </a>
                        </li>
                        <li v-else>
                            <a href="#" @click="currentLang = 'en'" style="padding: 0px; color: #F0F0F0"> EN </a>
                        </li>
                    </ul>  
                </div>
                <div class="divider"></div>
            </nav>
        </div>
    </div>
</template>

<script src='https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js'></script>

<script>
import firebase from "firebase";
export default {
    name: 'userNavigation',
    data(){
        return {
            currentLang: 'de'
        }
    },

    created(){
        this.currentLang = this.$i18n.locale
    },

    watch: {
        currentLang(locale){
            import (`../langs/${locale}.json`).then((msgs) => {
                this.$i18n.setLocaleMessage(locale, msgs)
                this.$i18n.locale = locale
            })
        }
    },

    mounted(){
        var selectInit = document.querySelectorAll(".dropdown-trigger");
        var instances = M.Dropdown.init(selectInit, {});
    },

    methods: {
        logoutBtnTapped() {
            firebase
            .auth()
            .signOut()
            .then(
            () => {
                this.$router.replace("/");
            },
            error => {
                console.log(error);
            }
            );
        }
    }
}
</script>